export enum TradeType {
	In,
	Out,
}
